import React from 'react';

// Scryfall serves an SVG per symbol code. Hybrid and phyrexian symbols drop the
// slash in the URL: {G/U} -> GU.svg, {2/W} -> 2W.svg, {G/P} -> GP.svg.
export const manaSymbolUrl = code =>
  `https://svgs.scryfall.io/card-symbols/${String(code)
    .replace(/\//g, '')
    .toUpperCase()}.svg`;

const SYMBOL_PATTERN = /\{([^}]+)\}/g;

/**
 * Turns a card's mana cost or rules text into an array of React nodes, replacing
 * every {X} token with its Scryfall symbol image and leaving the rest as text.
 */
export const renderCardText = text => {
  if (!text) return null;

  const nodes = [];
  let lastIndex = 0;
  let match;

  SYMBOL_PATTERN.lastIndex = 0;
  while ((match = SYMBOL_PATTERN.exec(text)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(text.slice(lastIndex, match.index));
    }
    nodes.push(
      <img
        key={`${match.index}-${match[1]}`}
        className="inline h-4 w-4 align-text-bottom"
        src={manaSymbolUrl(match[1])}
        alt={`{${match[1]}}`}
        title={`{${match[1]}}`}
      />,
    );
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }

  return nodes;
};

const manaSymbols = { manaSymbolUrl, renderCardText };

export default manaSymbols;
